import { useCallback } from "react";
import { useNavigate } from "@tanstack/react-router";

export interface AppNavigateOptions {
  to: string;
  params?: Record<string, string>;
  search?: Record<string, string>;
  title?: string;
  /** Replace the current history entry (redirects) instead of pushing a new one. */
  replace?: boolean;
}

/**
 * Navigate through TanStack Router.
 *
 * Usage:
 *   const navigate = useAppNavigate();
 *   navigate({ to: "/specPilot/$jobId", params: { jobId }, title: job.name });
 */
export function useAppNavigate() {
  const routerNavigate = useNavigate();

  return useCallback(
    (options: AppNavigateOptions) => {
      routerNavigate({
        to: options.to as "/",
        params: options.params,
        search: options.search,
        replace: options.replace,
      });
    },
    [routerNavigate]
  );
}
